import styles from "./index.module.scss";
import PortfolioLoadingDots from "./PortfolioLoadingDots";

export default function PortfolioVerifiedAt({ verifiedAt, isLoading }) {
  if (isLoading) {
    return (
      <div className={styles.portfolioVerifiedAt} aria-busy="true" aria-label="Loading">
        <PortfolioLoadingDots />
      </div>
    );
  }

  if (!verifiedAt?.time) {
    return <p className={styles.portfolioStatValue}>—</p>;
  }

  return (
    <div className={styles.portfolioVerifiedAt}>
      <div className={styles.portfolioVerifiedTimeRow}>
        <span className={styles.portfolioStatValue}>{verifiedAt.time}</span>
        <span className={styles.portfolioVerifiedUtc}>UTC</span>
        <span className={styles.portfolioVerifiedDate}>{verifiedAt.date}</span>
      </div>
    </div>
  );
}
